import React from 'react';
import { withRouter } from 'react-router-dom';

import { getSpecialisationFromLocation } from 'utils/utils';

const withRouterSpecialisation = CustomComponent =>
  withRouter(props => {
    const { location } = props;
    const specialisation = getSpecialisationFromLocation(location);

    return <CustomComponent specialisation={specialisation} {...props} />;
  });

export default withRouterSpecialisation;
